import { addDays } from 'date-fns/addDays';
import { addHours } from 'date-fns/addHours';
import { format } from 'date-fns/format';
import { isSameDay } from 'date-fns/isSameDay';
import { nextMonday } from 'date-fns/nextMonday';
import { setHours } from 'date-fns/setHours';
import { startOfDay } from 'date-fns/startOfDay';

import { formatTime } from '@/utils/date';

export type SnoozeOption = {
  id: 'later_today' | 'tomorrow' | 'next_week';
  label: string;
  until: Date;
};

const LATER_TODAY_HOURS = 3;
const MORNING_HOUR = 9;

export const snoozeWhenLabel = (until: Date, now: Date) =>
  isSameDay(until, now)
    ? formatTime(until)
    : `${format(until, 'EEE')} ${formatTime(until)}`;

const morningOf = (day: Date): Date => setHours(startOfDay(day), MORNING_HOUR);

// Later today drops out once three hours on would run into tomorrow
export const snoozeOptionsAt = (now: Date): SnoozeOption[] => {
  const laterToday = addHours(now, LATER_TODAY_HOURS);
  return [
    ...(isSameDay(laterToday, now)
      ? [
          {
            id: 'later_today' as const,
            label: 'Later today',
            until: laterToday,
          },
        ]
      : []),
    { id: 'tomorrow', label: 'Tomorrow', until: morningOf(addDays(now, 1)) },
    { id: 'next_week', label: 'Next week', until: morningOf(nextMonday(now)) },
  ];
};
